import React, { useEffect, useState, useRef } from 'react';
interface ScrollRevealProps {
  children: React.ReactNode;
  direction?: 'up' | 'left' | 'right' | 'fade';
  delay?: number;
  className?: string;
}
export function ScrollReveal({
  children,
  direction = 'up',
  delay = 0,
  className = ''
}: ScrollRevealProps) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      }
    }, {
      threshold: 0.1,
      rootMargin: '50px'
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);
  const getTransform = () => {
    if (isVisible) return 'translate(0, 0) scale(1)';
    switch (direction) {
      case 'up':
        return 'translateY(40px)';
      case 'left':
        return 'translateX(-40px)';
      case 'right':
        return 'translateX(40px)';
      case 'fade':
        return 'scale(0.95)';
      default:
        return 'translateY(40px)';
    }
  };
  return <div ref={ref} className={className} style={{
    opacity: isVisible ? 1 : 0,
    transform: getTransform(),
    transition: `opacity 0.8s ease-out, transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)`,
    transitionDelay: `${delay}ms`
  }} data-id="element-193">
      {children}
    </div>;
}